/** @type {import("vuex").GetterTree} */
export const getters = {
    getRegistrationAtIndex: (state) => (index) => {
        if (index < 0 || index >= state.registrations.length) return undefined;
        return state.registrations[index];
    }
};

export default getters;
